<template>
  <div class="options">
    <search v-model="search" class="search" />
    <el-button type="primary" icon="el-icon-plus" @click="showDialog = true">Invite member</el-button>

    <el-dialog :append-to-body="true" width="400px" custom-class="full-width-mobile" class="invite-member-dialog" title="Invite member" :visible.sync="showDialog">
      <invite-member-dialog v-if="showDialog" @sent="onSent" />
    </el-dialog>
  </div>
</template>

<script>
import InviteMemberDialog from './InviteMemberDialog'
import Search from './../SearchInput'

export default {
  name: 'Options',
  components: { InviteMemberDialog, Search },
  data () {
    return {
      search: '',
      showDialog: false
    }
  },
  watch: {
    search () {
      this.$emit('search', this.search)
    }
  },
  methods: {
    onSent (data) {
      this.showDialog = false
      this.$emit('invited', data)
    }
  }
}
</script>

<style lang="scss" scoped>
  .options {
    width: 50%;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    @include breakpoint (xs) {
      width: 100%;
      flex-direction: column;

      button {
        width: 100%;
        height: 60px;
      }
    }
  }

  .search {
    width: 100%;
    margin-right: 20px;

    @include breakpoint (xs) {
      margin-right: 0px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/Members/Options.vue